/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { Breadcrumbs } from '@neo4j-ndl/react';
import { type Meta, type StoryObj } from '@storybook/react-vite';

import {
  BreadcrumbsEllipses,
  BreadcrumbsEllipsesSrc,
  BreadcrumbsHeader,
  BreadcrumbsHeaderSrc,
  BreadcrumbsPages,
  BreadcrumbsPagesSrc,
  BreadcrumbsSteps,
  BreadcrumbsStepsSrc,
} from '.';

const componentMeta = {
  component: Breadcrumbs,
  parameters: {
    controls: { disable: true },
  },
  tags: ['docsPage'],
  title: 'Components/Breadcrumbs',
  id: 'components-breadcrumbs',
} satisfies Meta<typeof Breadcrumbs>;

export default componentMeta;
type Story = StoryObj<typeof componentMeta>;

export const HeaderNavigation: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: BreadcrumbsHeaderSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: BreadcrumbsHeader,
};

export const PageNavigation: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: BreadcrumbsPagesSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: BreadcrumbsPages,
};

export const MultiStepNavigation: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: BreadcrumbsStepsSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: BreadcrumbsSteps,
};

export const Ellipses: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: BreadcrumbsEllipsesSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: BreadcrumbsEllipses,
};
